module.exports = __webpack_public_path__ + "static/media/logo.45a3801c.png";